import React from 'react'
import logo from "../../assets/logos/TRANSKYRIOS-_IconColor.avif";
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import Permiso from '../../components/wrappers/permiso';
import ContactoTI from "../../components/contacto-ti/contacto-ti";
import ModuleLayout from '../../layouts/layout-modulo.js';

function PanelConductor() {
  const navigate = useNavigate();

  const chkSomnolencia = () => { navigate('crear/checklist-somnolencia'); };
  const chkVehiculo = () => { navigate('crear/checklist-vehiculo'); };

  const miChkSomnolencia = () => { navigate('ver/mi-somnolencia'); };
  const miChkVehiculo = () => { navigate('ver/mi-revision-vehicular'); }

  return (
    <ModuleLayout titulo="Panel del Conductor" logo={logo} onVolver={() => navigate('/app')}>
      <section className="mod-content">
        <div className='mod-banner'>
          <p className="m-0">
            Aquí podrá gestionar algunas de las operaciones relacionadas con la conducción de vehículos, 
            como los checklist diarios y pronto mucho más. 
          </p>
        </div>

        <div className='container-cards'>
          <Permiso modulo="Panel Conductor" permiso="CON_CREAR_REGSOM">
            <div className="mod-card">
              <Card
                title="Checklist Somnolencia"
                className="card-dash"
                footer={<Button className="btn btn-primary" label="Crear Nuevo" icon="pi pi-plus" onClick={chkSomnolencia}/>}
              >
                <p>
                  Antes de iniciar su viaje, evalúe su nivel de descanso y concentración 
                  para garantizar una conducción segura.
                </p>
              </Card>
            </div>
          </Permiso>

          <Permiso modulo="Panel Conductor" permiso="CON_CREAR_REGVEH">
            <div className="mod-card">
              <Card
                title="Checklist Vehicular"
                className="card-dash"
                footer={ <Button className="btn btn-primary" label="Crear Nuevo" icon="pi pi-plus" onClick={chkVehiculo} />}
              >
                <p>
                  Verifique que su vehículo asignado se encuentre en condiciones 
                  óptimas para su funcionamiento.
                </p>
              </Card>
            </div>
          </Permiso>

          <Permiso modulo="Panel Conductor" permiso="CON_VER_REGSOM">
            <div className="mod-card">
              <Card
                title="Mis Registros: Fatiga y Somnolencia"
                className="card-dash"
                footer={ 
                  <Button className="btn btn btn-outline-primary" 
                    label="Ver Registros" 
                    icon="pi pi-table" 
                    onClick={miChkSomnolencia} 
                  />
                }
              >
                <p>
                  Aquí podrá consultar su historial de checklists de fatiga y somnolencia.
                  Estos registros le permitirán llevar un mejor control de su estado y asegurar 
                  que cada viaje se realice en condiciones óptimas.
                </p>
              </Card>
            </div>
          </Permiso>

          <Permiso modulo="Panel Conductor" permiso="CON_VER_REGVEH">
            <div className="mod-card">
              <Card
                title="Mis Registros: Revisión Vehicular"
                className="card-dash"
                footer={ 
                  <Button className="btn btn btn-outline-primary" 
                    label="Ver Registros"
                    icon="pi pi-table" 
                    onClick={miChkVehiculo} 
                  />
                }
              >
                <p>
                  Aquí podrá consultar el historial de checklists vehiculares que ha completado.
                  Cada registro corresponde a una revisión realizada del vehículo asignado, 
                  indicando su estado y observaciones.
                </p>
              </Card>
            </div>
          </Permiso>
        </div>
        
        <ContactoTI />
      </section>
    </ModuleLayout>
  );
}

export default PanelConductor